// extracted by mini-css-extract-plugin
module.exports = {"Emojis__item":"tm_a vh_si vh_ot vh_tj"};